import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "initials"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_el_image = _resolveComponent("el-image")

  return (_openBlock(), _createBlock(_component_el_image, {
    class: _normalizeClass(["image", {[$props.shape]: true}]),
    fit: "cover",
    src: $props.src
  }, {
    error: _withCtx(() => [
      ($props.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            shape: $props.shape,
            width: $props.size,
            height: $props.size
          }, null, 8 /* PROPS */, ["shape", "width", "height"]))
        : ($options.initials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($options.initials), 1 /* TEXT */))
          : (_openBlock(), _createBlock(_component_el_image, {
              key: 2,
              src: $props.placeholder
            }, null, 8 /* PROPS */, ["src"]))
    ]),
    placeholder: _withCtx(() => [
      ($props.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            shape: $props.shape,
            width: $props.size,
            height: $props.size
          }, null, 8 /* PROPS */, ["shape", "width", "height"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "src"]))
}